import { useContext } from "react";
import config from "../../../config";
import { useMutation } from "@tanstack/react-query";
import { AppContext } from "@/App.context";

/**
 * @typedef EditUserReq
 * @property {boolean} active
 * @property {number[]} id
 * @property {string} name
 *
 */

/**
 * @typedef EditUserRes
 * @property {string} message
 */

const getupdateSetting = (token) => {
  /**
   * @param {EditUserReq} req
   * @returns {Promise<EditUserRes>}
   */
  return async (data, id) => {
    const editUser = await fetch(`${config.apiHost}/v1/settings/update`, {
      method: "PUT",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    if (!editUser.ok) {
      throw new Error((await editUser.json()).message);
    }
    const groupStatus = await editUser.json();
    return groupStatus;
  };
};

export const useUpdateSettings = (type) => {
  const appContext = useContext(AppContext);

  const mutation = useMutation({
    mutationKey: ["getupdateSetting", type],
    mutationFn: (body) =>
      getupdateSetting(appContext.idToken)({ ...body, type }),
  });

  return mutation;
};
